// Begin when all assets are loaded and ready
window.addEventListener("load", function () {
    startAnimation();
});
startAnimation = function () {
    //abort animations if cookie present
    let animate = getCookie("animate");
    if (animate === "0") return;

    //set up scroll trigger
    gsap.registerPlugin(ScrollTrigger);
    gsap.registerPlugin(DrawSVGPlugin); 
    gsap.registerPlugin(SplitText); 

    //suppress warnings when block doesn't appear on page
    gsap.config({
        nullTargetWarn: false,
    });

    ScrollTrigger.defaults({
        //markers: true
    });

    //set up mobile detection
    let mm = gsap.matchMedia();
    mm.add({
        isMobile: "(max-width: 767px)",
        isDesktop: "(min-width: 768px)",
    }, (context) => {

        let { isMobile, isDesktop } = context.conditions;

        // Video fact block
        if (isDesktop) {
            let videos = gsap.utils.toArray('.ar-video-fact-block__video');
            videos.forEach(video => {
                gsap.to(video, {
                    scrollTrigger: {
                        id: 'video fact block',
                        start: "top bottom",
                        trigger: video,
                        onToggle: self => self.isActive ? video.play() : video.pause(),
                        //markers: true
                    },
                });
            });
        }

        // Section highlight block
        if (isDesktop) {
            let sectionHighlightBlocks = gsap.utils.toArray('.ar-section-highlight-block__container');

            sectionHighlightBlocks.forEach((sectionHighlightBlock) => {
                let imageContainer = sectionHighlightBlock.querySelector(".ar-section-highlight-block__image-container");
                let image = imageContainer.querySelector("img");
                let contentContainer = sectionHighlightBlock.querySelector(".ar-section-highlight-block__content");
                let title = sectionHighlightBlock.querySelector(".ar-section-highlight-block__section-title");

                let tl = gsap.timeline({
                    scrollTrigger: {
                        id: 'section highlight block',
                        start: "50% bottom",
                        trigger: sectionHighlightBlock,
                        //markers: true
                    },
                    //repeat: -1
                });

                //switch animation for left/right alignment
                if (sectionHighlightBlock.classList.contains('ar-section-highlight-block_image-left')) {
                    tl
                        //.from(imageContainer, { x: -100, opacity: 0, duration: 1 })
                        .from(image, { opacity: 0, scale: 1.1, duration: 1 })
                        .from(title, { opacity: 0, duration: 1 }, ">-0.75")
                        .from(contentContainer, { x: 50, opacity: 0, duration: 0.5 }, ">-0.5");
                }
                else {
                    tl
                        .from(image, { opacity: 0, scale: 1.1, duration: 1 })
                        .from(title, { opacity: 0, duration: 1 }, ">-0.75")
                        .from(contentContainer, { x: -50, opacity: 0, duration: 0.5 }, ">-0.5");
                }


            });
        }

        // Click through link block
        gsap.from(".ar-click-through-link-block__link", {
            scrollTrigger: {
                id: 'click through link block',
                start: "50% bottom",
                trigger: ".ar-click-through-link-block",
                //markers: true
            },
            y: -30,
            opacity: 0,
            duration: 0.5,
            stagger: 0.2
        });

        // Team listing block
        if (isMobile) { 
            //mobile animates each member
            const teamMembers = gsap.utils.toArray('.ar-team-listing-block .team-member');
            teamMembers.forEach((teamMember, i) => {
                gsap.from(teamMember, {
                    opacity: 0,
                    scale: 0.95,
                    y: 10,
                    scrollTrigger: {
                        trigger: teamMember,
                        id: 'team listing block',
                        start: "10% bottom",
                        //markers: true
                    }
                })
            });
        } else {
            //tablet or above animates all in sequence for controlled stagger
            gsap.from(".ar-team-listing-block .team-member", {
                scrollTrigger: {
                    id: 'team listing block',
                    start: "50% bottom",
                    trigger: ".ar-team-listing-block .team-member",
                    //markers: true
                },
                opacity: 0,
                scale: 0.95,
                y: 10,
                stagger: 0.15
            });
        }

    });
}
